import { render } from "./IdentityGraph.vue?vue&type=template&id=617bbddd"
import script from "./IdentityGraph.vue?vue&type=script&lang=js"
export * from "./IdentityGraph.vue?vue&type=script&lang=js"

import "./IdentityGraph.vue?vue&type=style&index=0&id=617bbddd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__